export default function getResource(label, vars = []) {
    const resources = {
        pickAStore: 'Choisir un magasin',
        showMap: 'Afficher la carte',
        hideMap: 'Masquer la carte',
        showMoreLocations: 'Afficher plus d’emplacements',
        continueToPickArtist: 'Continuer pour choisir un(e) artiste, une date et une heure'
    };

    return resources[label];
}
